export const CATEGORY_COLORS = {
    rose: 'fb7185',
    pink: 'f472b6',
    fuchsia: 'e879f9',
    violet: 'a78bfa',
    blue: '60a5fa',
    sky: '38bdf8',
    emerald: '34d399',
    lime: 'a3e635',
    amber: 'fbbf24',
    orange: 'fb923c',
    slate: '94a3b8',
} as const;

export const CATEGORY_COLORS_OPTIONS: { label: string; value: string }[] = Object.entries(CATEGORY_COLORS).map(
    ([label, value]) => ({ label, value })
);
